import styled, { css } from 'styled-components';

export const DialogBody = styled.div`
  display: flex;
  flex-direction: column;

  ${({ theme: { spacing } }) => css`
    padding: ${spacing.level3} 0;
  `}
`;

export const MarkdownContent = styled.div`
  line-height: 1.6;

  ${({ theme: { colors, font, spacing } }) => css`
    font-size: ${font.bodyMedium.fontSize};
    color: ${colors.onSurfaceVariant};

    p {
      margin: 0 0 ${spacing.level4};
    }

    p:last-child {
      margin-bottom: 0;
    }

    strong {
      font-weight: 600;
      color: ${colors.onSurface};
    }

    a {
      color: ${colors.primary};
      font-weight: ${font.labelLarge.fontWeight};
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

    ul,
    ol {
      margin: 0 0 ${spacing.level4};
      padding-left: 1.5em;
    }

    li {
      margin-bottom: ${spacing.level2};
    }
  `}
`;
